import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import {
  isContractPaused,
  PauseMintBurn,
  resumeMintBurn,
} from "../Web3/Methods";
import { useActiveAccount } from "thirdweb/react";

export default function Pauser({ selectedToken: parentSelectedToken = "ICUSD" }) {
  const [contractpaused, setContractPaused] = useState(false);
  const [selectedToken, setSelectedToken] = useState(parentSelectedToken);
   const account = useActiveAccount();
  // Sync with parent's selected token
  useEffect(() => {
    setSelectedToken(parentSelectedToken);
  }, [parentSelectedToken]);

  const error = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  const pause = async () => {
    try {
      const data = await PauseMintBurn(selectedToken, account?.address);
      if (data.status) {
        sucess("Paused Successfully");
        const paused = await isContractPaused(selectedToken, account?.address);
        setContractPaused(paused);
      } else {
        error("Could not Paused");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resume = async () => {
    try {
      const data = await resumeMintBurn(selectedToken, account?.address);
      if (data.status) {
        sucess("Resumed Successfully");
        const paused = await isContractPaused(selectedToken);
        setContractPaused(paused);
      } else {
        error("Could not Resume");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" my-5">
      <Toaster />
      {/* <h3>CONTRACT IS PAUSED</h3> */}
      <div className="row my-5">
        <div className="col-md-6 my-2 my-md-0">
          <Button variant="primary" type="submit" onClick={() => pause()}>
            Pause
          </Button>
        </div>
        <div className="col-md-6">
          <Button variant="primary" type="submit" onClick={() => resume()}>
            Resume
          </Button>
        </div>
      </div>
    </div>
  );
}
